import { render, staticRenderFns } from "./SigaCallStatus.vue?vue&type=template&id=45154d8c&"
import script from "./SigaCallStatus.vue?vue&type=script&lang=js&"
export * from "./SigaCallStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports